
import React, { Component } from "react";
import {Link} from "gatsby";

class Left extends Component {
  render() {
    return (
      <div className="container-z-c2">
        <div className="widget-z-c1">
          <div className="widget-z-c1-header"># Chủ đề nổi bật</div>
          <div className="widget-z-c1-body">
            <ul className="list-group-z-c1-nav">
              <li className="list-group-z-c1-nav-item">
                <Link to="/" key="/" className="list-group-z-c1-nav-link">
                  Truyện hay
                </Link>
              </li>
              <li className="list-group-z-c1-nav-item">
                <Link to="/" key="/" className="list-group-z-c1-nav-link">
                  Công thức
                </Link>
              </li>
              <li className="list-group-z-c1-nav-item">
                <Link to="/" key="/" className="list-group-z-c1-nav-link">
                  Lập trình
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="widget-z-c1 widget-z-c1-last">
          <div className="widget-z-c1-header"># Tag nổi bật</div>
          <div className="widget-z-c1-body">
            <ul className="list-group-z-c1-nav">
              <li className="list-group-z-c1-nav-item">
                <Link to="/" key="/" className="list-group-z-c1-nav-link">
                  SEO
                </Link>
              </li>
              <li className="list-group-z-c1-nav-item">
                <Link to="/" key="/" className="list-group-z-c1-nav-link">
                  Wordpress
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Left;
